import {
  GET_SUPPLIERS_SUCCESS,
  GET_SUPPLIERS_FAIL,
  DELETE_SUPPLIER_SUCCESS,
  GET_SUPPLIERS,
  EDIT_SUPPLIER,
  EDIT_SUPPLIER_SUCCESS,
  EDIT_SUPPLIER_CLEAN,
  DELETE_SUPPLIER,
  SAVE_SUPPLIER_PROFILE,
  GET_SUPPLIER_PROFILE,
  SAVE_SUPPLIER_PROFILE_SUCCESS,
  GET_FILE_REQUIREMENT_SUPPLIER,
  GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS,
  GET_FILE_REQUIREMENT_SUPPLIER_FAIL,
  EXPORT_SUPPLIER_SUCCESS,
  EXPORT_SUPPLIER_FAIL,
  DATA_EXPORT_SUPPLIER_CLEAN
} from "./actionTypes"

const INIT_STATE = {
  suppliers: {
    list: [],
    countList: 0,
  },
  types: [],
  error: "",
  loading: true,
  loadingSave: false,
  response: null,
  supplierProfile: {},
  fileRequirement: [],
  dataExport: [],
  dataPending: false,
}

const suppliers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case EDIT_SUPPLIER_CLEAN:
      return {
        ...state,
        response: null,
        //loading: false,
        loadingSave: false,
        error: "",
      }
    case EDIT_SUPPLIER:
      return {
        ...state,
        loadingSave: true,
        error: "",
        response: null,
      }
    case EDIT_SUPPLIER_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        error: "",
        response: action.payload,
      }
    case GET_SUPPLIERS:
      return {
        ...state,
        suppliers: [],
        loading: true,
      }
    case GET_SUPPLIERS_SUCCESS:
      return {
        ...state,
        suppliers: action.payload,
        loading: false,
      }

    case GET_SUPPLIERS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
      }
    case DELETE_SUPPLIER:
      return {
        ...state,
        response: null,
        loading: true,
      }
    case SAVE_SUPPLIER_PROFILE:
      return {
        ...state,
        supplierProfile: action.payload.data,
        loading: true,
      }
    case GET_SUPPLIER_PROFILE:
      return {
        ...state,
        supplierProfile: action.payload.data,
        loading: true,
      }
    case SAVE_SUPPLIER_PROFILE_SUCCESS:
      return {
        ...state,
        supplierProfile: action.payload.data,
        loading: true,
      }
    case GET_FILE_REQUIREMENT_SUPPLIER:
      return {
        ...state,
        loading: true,
        fileRequirement: [],
      }
    case GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        fileRequirement: action.payload.data,
      }
    case GET_FILE_REQUIREMENT_SUPPLIER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case EXPORT_SUPPLIER_SUCCESS:
      return {
        ...state,
        dataExport: action.payload.data,
        dataPending: true
      }
    case DATA_EXPORT_SUPPLIER_CLEAN:
      return {
        ...state,
        dataExport: [],
        dataPending: false
      }
    default:
      return state
  }
}

export default suppliers
